import axiosInstance from "../Axios/axiosInstance";

const executeMigration = async () => {
  return await axiosInstance.get("/medicalNetworks/read");
};

export default {
  executeMigration,
};
